import React from 'react';

import { Box } from '@chakra-ui/react';
import {
  ListItemText,
  NavGroupL2,
  NavGroupTitleL2,
  NavItemL2,
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@mesh.ai/rabbit';
import { useRouteMatch, NavLink, matchPath, useLocation } from 'react-router-dom';

import BetaTag from 'uiToolkitV1/Tag/BetaTag';

const activeClassName = 'active-L2';

type ItemProps = {
  label: string;
  value: string | string[];
  type?: '';
  key: string;
  hide?: () => boolean;
  isBeta?: boolean;
};

type GroupProps = {
  label: string;
  type?: 'group';
  basePath: string;
  items: ItemProps[];
  hide?: () => boolean;
};

export type NavMenuItemsProps = (ItemProps | GroupProps)[];

type Props = {
  menuTitle: string;
  menuItems: NavMenuItemsProps;
  hasLeftPadding?: boolean;
};

const NonGroupLink = ({ item }: { item: ItemProps }) => {
  const isActiveRoute = useRouteMatch({ path: item.value, exact: false });

  return (
    <NavLink
      key={Array.isArray(item.value) ? item.value?.toString() : item.value}
      to={Array.isArray(item.value) ? item.value[0] : item.value}
      activeClassName={activeClassName}
      isActive={Array.isArray(item.value) ? () => Boolean(isActiveRoute) : undefined}
    >
      <NavItemL2 className="mb-1 w-full">
        <ListItemText title={item.label} />
        {item.isBeta ? <BetaTag /> : null}
      </NavItemL2>
    </NavLink>
  );
};

// TODO: Discuss with Nishanth why this is used? And why value is being checked for pathname?
const checkActive = ({ pathname, value }) => value.includes(pathname);

const L2NavMenu = ({ menuTitle, menuItems, hasLeftPadding }: Props) => {
  const { pathname } = useLocation();
  return (
    <NavGroupL2>
      <NavGroupTitleL2>{menuTitle}</NavGroupTitleL2>
      <Box ml={hasLeftPadding ? -5 : 0}>
        {menuItems
          .filter((item) => !(item?.hide && item?.hide()))
          .map((item) => {
            if (item?.type === 'group') {
              const isAccordionExpanded = matchPath(pathname, { path: item.basePath }) !== null;

              const { label: groupLabel, items } = item;
              return (
                <Accordion
                  type="single"
                  collapsible
                  defaultValue={isAccordionExpanded ? `singleGroupAccordion${groupLabel}` : undefined}
                >
                  <AccordionItem value={`singleGroupAccordion${groupLabel}`} className="mb-2">
                    <AccordionTrigger className="w-full py-1">
                      <ListItemText title={groupLabel} />
                    </AccordionTrigger>
                    <AccordionContent>
                      {items.map(({ value, label }) => (
                        <NavLink
                          key={Array.isArray(value) ? value?.toString() : value}
                          to={Array.isArray(value) ? value[0] : value}
                          activeClassName={activeClassName}
                          isActive={Array.isArray(value) ? () => checkActive({ pathname, value }) : undefined}
                        >
                          <NavItemL2 className="mb-1">
                            <ListItemText title={label} />
                          </NavItemL2>
                        </NavLink>
                      ))}
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              );
            }

            return <NonGroupLink item={item} />;
          })}
      </Box>
    </NavGroupL2>
  );
};

export { L2NavMenu };
